import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';
import { injectIntl, defineMessages } from 'react-intl';

import * as configActions from 'modules/config';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';

import { ConfigTemplate, MyPageTemplate, MyPageTitle } from 'components';
import { CtSmtpTest, CtConfigInitial } from 'containers';

class CtEduConf extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: 0
      //initValue: {}
    };
  }

  componentDidMount() {
    this.getServiceConfig();
  }

  getServiceConfig = async () => {
    const { ConfigActions, paramInfo } = this.props;

    try {
      await ConfigActions.getServiceConfig({ category: 'edu' });
    } catch (e) {
      console.log(e);
    }

    this.setState({ loaded: 1 });
  };

  render() {
    if (this.state.loaded === 0) {
      return null;
    }

    // 국제화 처리
    const { formatMessage } = this.props.intl;

    const { configClassOrder, configParamOrder, mailSmtpTested } = this.props;

    let classOrder = [];
    if (configClassOrder && List.isList(configClassOrder)) {
      classOrder = configClassOrder.toJS();
    }

    let paramOrder = {};
    if (configParamOrder && Map.isMap(configParamOrder)) {
      paramOrder = configParamOrder.toJS();
    }

    return (
      <MyPageTemplate>
        <MyPageTitle small title={defineMessages(formatMessage({ id: 'MyPageMenu_10', defaultMessage: '교육설정' }))} />
        <ConfigTemplate category="eduConfig" order={classOrder} lists={paramOrder} />
      </MyPageTemplate>
    );
  }
}

const mapStateToProps = state => {
  return {
    configClassOrder: state.config.getIn(['eduConfig', 'classOrder']),
    configParamOrder: state.config.getIn(['eduConfig', 'class'])
  };
};

const mapDispatchToProps = dispatch => ({
  ConfigActions: bindActionCreators(configActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtEduConf));



// WEBPACK FOOTER //
// ./src/script/containers/config/CtEduConf.js